import React, { useState } from "react";
import MonitoringListActiveTable from "./MonitoringListActiveTable";
import MonitorsListViewFilter from "./MonitorsListViewFilter";
import JsonCollapse from "../Builder/Components/JsonCollapse";

function MonitorsListView() {
  const [filters, setFilters] = useState({});
  return (
    <div>
      <div className="mb-3">
        <MonitorsListViewFilter filters={filters} setFilters={setFilters} />
      </div>

      <div className="text-black fw-bold">
        <MonitoringListActiveTable filters={filters} />
      </div>
      <JsonCollapse json={filters} />
    </div>
  );
}

export default MonitorsListView;
